import * as React from 'react'
import FindIcon from '../icons/ui/Find'

export interface IAssistanceSearchProps {
  onInputChange: (query: string) => void
}

const AssistanceSearch = ({ onInputChange }: IAssistanceSearchProps) => {
  return (
    <div className='flex items-center mr3'>
      <input className='AssistanceSearchInput mr1' type='text' onChange={createOnChangeHandler()} />
      <FindIcon className='svg-stroke-grey3' />
    </div>
  )

  function createOnChangeHandler() {
    return (e: any) => onInputChange(e.target.value)
  }
}

export default AssistanceSearch



// WEBPACK FOOTER //
// ./src/components/assistance/AssistanceSearch.tsx